<template>
    <v-row justify="center">
        <v-dialog v-model="showDialog" persistent max-width="350">
            <v-card>
                <v-card-title class="headline pt-1 pr-1 custom-card-header">
                    Update Status
                    <v-spacer></v-spacer>
                    <v-btn icon @click="toggle" dark><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <br />
                <v-card-text class="pb-1"> Choosing a status of Unassigned or Delayed will remove this task from the Route.</v-card-text>

                <v-autocomplete
                    label="Update Status"
                    :items="statusOptions"
                    v-model="selectedStatus"
                    outlined
                    clearable
                    class="ma-2"
                >
                </v-autocomplete>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="primary" class="ma-2" @click="updateStatus">Update</v-btn>
                    <v-btn color="primary" outlined class="ma-2" @click="toggle">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
    import { mapActions } from 'vuex'
    export default {
        props: {
            showDialog: {
                type: Boolean,
                required: true
            },
            toggle: {
                type: Function,
                required: true
            },
            jobTask: {
                type: Object
            },
        },
        data() {
            return {
                statusOptions: ['Unassigned', 'Assigned', 'InProgress', 'Delayed', 'Complete','Reassigned'],
                selectedStatus: null,
            }
        },
        methods: {
            ...mapActions({
                updateTask: 'jobTasks/update',
            }),
            async updateStatus () {
                //if there is a status selected, update the task's status
                if(this.selectedStatus) {
                    this.jobTask.status = this.selectedStatus
                }
                //remove tasks that are unassigned or delayed from the route
                if(this.jobTask.status === 'Unassigned' || this.jobTask.status === 'Delayed'){
                    this.jobTask.routeId = null;
                }
                await this.updateTask(this.jobTask)
                await this.toggle()
            }
        },
        watch: {
            jobTask () {
                if(this.jobTask){
                    this.selectedStatus = this.jobTask.status
                } else {
                    this.selectedStatus = null
                }
            }
        }
    }
</script>
<style scoped>
    .custom-card-header {
        background-color: #00A5C5;
        color: white;
    }
</style>
